var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreasureHunters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 0.208252H16.3332C17.0957 0.208252 17.8269 0.511153 18.3661 1.05032C18.9053 1.58949 19.2082 2.32075 19.2082 3.08325V6.91659H12.4998V5.95825H6.74984V6.91659H0.0415039V3.08325C0.0415039 2.32075 0.344405 1.58949 0.883572 1.05032C1.42274 0.511153 2.15401 0.208252 2.9165 0.208252ZM8.6665 6.91659H10.5832V8.83325H8.6665V6.91659ZM0.0415039 7.87492H6.74984V8.83325L8.6665 10.7499H10.5832L12.4998 8.83325V7.87492H19.2082V15.5416H0.0415039V7.87492Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureHunters);
export default __webpack_public_path__ + "static/media/TreasureHunters.33b76c0968d8b0b3cf6ca80432d341db.svg";
export { ForwardRef as ReactComponent };